import { FIGURE_MONEY, getFormatter } from 'Angular/utils/number_formatter';
export const DEFAULT_YEAR_LOOKBACK = 5;
export const DEFAULT_DISTRIBUTION_TYPE = 'shares';
export const DEFAULT_CUSTOM_VALUE = 1;
export const FETCH_DEBOUNCE_MS = 300;
const moneyFormatter = getFormatter(FIGURE_MONEY, 'USD');
export const FUND_HISTORIC_DISTRIBUTION_CONFIGURABLE_OPTIONS = {
    currencyCode: 'USD',
    tooltipValueDecimals: 2,
    tooltipStyle: 'box',
    tooltipItemized: true,
    tooltipShowTotal: true,
};
export const FUND_HISTORIC_DISTRIBUTION_CHART_OPTIONS = {
    xAxis: {
        crosshair: false,
        labels: {
            style: {
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#191919',
            },
        },
        lineColor: '#cccccc',
    },
    yAxis: {
        labels: {
            style: {
                fontSize: '12px',
                color: '#999999',
            },
        },
        // The total above each column, as in the design.
        stackLabels: {
            enabled: true,
            formatter() {
                return moneyFormatter(this.total, 2);
            },
            style: {
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#191919',
                textOutline: 'none',
            },
        },
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            borderWidth: 0,
            pointPadding: 0.08,
            groupPadding: 0.18,
            maxPointWidth: 88,
        },
        series: {
            states: {
                hover: {
                    enabled: true,
                    brightness: 0.1,
                },
                inactive: {
                    enabled: true,
                    opacity: 0.3,
                },
            },
        },
    },
    tooltip: {
        followPointer: false,
    },
};
